import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import Swal from 'sweetalert2';

import { ProductTagService } from '@app/core/product-tags/services/product-tag.service';

@Component({
  selector: 'cnc-tags',
  templateUrl: './bulk-tags.component.html',
  styleUrls: ['./bulk-tags.component.scss'],
})
export class BulkTagsComponent implements OnInit {
  loading :boolean = false;
  tags :any[] = [];
  pageTitle :string = 'Bulk add tags';
  formData :UntypedFormGroup;
  unsubscribeTags :Subscription;
  constructor(
    public activeModal :NgbActiveModal,
    private tagSvc :ProductTagService,
    private fb :UntypedFormBuilder,
  ) {}

  ngOnInit() :void {
    this.loadTags();
    this.formData = this.fb.group({
      tags: [null, Validators.required],
    });
  }

  ngOnDestroy() :void {
    if (this.unsubscribeTags) {
      this.unsubscribeTags.unsubscribe();
    }
  }

  onSubmit() :void {
    if (this.formData.invalid) {
      Swal.fire({
        title: 'Form Error!',
        text: 'Please fill all the required fields.',
        type: 'error',
        confirmButtonText: 'Back to Form',
      });

      return;
    }
    this.activeModal.close(this.formData.get('tags').value);
  }

  customTagsSearchFn(term :any, item :any) :void {
    term = term.toLocaleLowerCase();

    return item.name
      .toLowerCase()
      .replace(/&nbsp;/gi, '')
      .includes(term);
  }

  private loadTags() :void {
    this.tagSvc.getTags({ parent_only: true }, null);
    this.unsubscribeTags = this.tagSvc.formattedRecord$.subscribe((tags :any) => {
      this.tags = tags;
    });
  }
}
